const parkingSummaryReducer = (previousState = {}, { type, payload }) => {
    if (type === 'UPDATE_PARKING_SUMMARY') {
        return payload.parkingSummary;
    }
    return previousState;
};
export default parkingSummaryReducer;
